/**
 * Restituisce vero se il valore in ingresso è una funzione
 *
 * @author Lorenzo Muscariello (lwbu)
 *
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function isFunction(obj) {
    return obj instanceof Function;
}
/**
 * Restituisce vero se il valore in ingresso è una stringa
 *
 * @author Lorenzo Muscariello (lwbu)
 */
export function isString(obj) {
    return (typeof obj === "string");
}
/**
 * Restituisce vero se il valore in ingresso è un array
 *
 * @author Riccardo Di Dato (shatsu)
 * @author Lorenzo Muscariello (lwbu)
 */
export function isArray(obj) {
    return Array.isArray(obj);
}
/**
 * Restituisce vero se il valore in ingresso è un array
 *
 * @author Riccardo Di Dato (shatsu)
 */
export function isArrayOf(obj, guard) {
    return isArray(obj) && obj.reduce((carry, cur) => {
        return carry && guard(cur);
    }, true);
}
/**
 * Restituisce vero se il valore è un hashman i cui valori sono tutti dello stesso tipo
 *
 * @author Riccardo Di Dato (shatsu)
 */
export function isMapOf(obj, guard) {
    if (!isObject(obj)) {
        return false;
    }
    const keys = Object.keys(obj);
    return keys.length == 0 || keys.reduce((carry, cur) => {
        return carry && guard(obj[cur]);
    }, true);
}
/**
 * Restituisce vero se il valore in ingresso è definito (!= null e != undefined)
 *
 * @author Lorenzo Muscariello (lwbu)
 */
export function isDefined(obj) {
    return (typeof obj !== "undefined" && obj != null);
}
/**
 * Restituisce vero se il valore in ingresso è un oggetto
 *
 * @author Lorenzo Muscariello (lwbu)
 */
export function isObject(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}
/**
 * Restituisce vero se il valore in ingresso è un booleano
 *
 * @author Lorenzo Muscariello (lwbu)
 */
export function isBoolean(obj) {
    return (typeof obj == "boolean");
}
/**
 * Restituisce vero se il valore in ingresso è documento HTML (object `HTMLDocument`)
 *
 * @author Lorenzo Muscariello (lwbu)
 */
export function isHTMLDocument(obj) {
    return (typeof obj == "object" &&
        obj !== null &&
        (prototypeIs(obj, /object HTMLDocument/)));
}
/**
 * Restituisce vero se il valore in ingresso è un documento XML (object `XMLDocument`)
 *
 * @author Lorenzo Muscariello (lwbu)
 */
export function isXMLDocument(obj) {
    return (typeof obj == "object" &&
        obj !== null &&
        (prototypeIs(obj, /object XMLDocument/) ||
            prototypeIs(obj, /object Document/) // older android fix
        ));
}
/**
 * Restituisce vero se il valore in ingresso è un numero
 *
 * @author Lorenzo Muscariello (lwbu)
 */
export function isNumber(data) {
    return (typeof data == "number");
}
/**
 * Restituisce vero se il valore in ingresso è un PlainObject (un singleton o una classe senza costruttore)
 *
 * @author Lorenzo Muscariello (lwbu)
 */
export function isPlainObject(obj) {
    if (!isObject(obj) ||
        obj.nodeType ||
        (obj === obj.window)
        || obj === null) {
        return false;
    }
    if (obj.constructor &&
        !({}).hasOwnProperty.call(obj.constructor.prototype, "isPrototypeOf")) {
        return false;
    }
    return true;
}
/**
 * Restituisce vero se il prototipo dell elemento risponde ad una determinata regular expression
 *
 * @author Lorenzo Muscariello (lwbu)
 */
function prototypeIs(obj, regex) {
    const x = Object.prototype.toString.call(obj).match(regex);
    if (x && x.length > 0)
        return true;
    else
        return false;
}
/**
 * Verifica che il valore sia un valore valido della enum. Notare che a causa di meccaniche interne a typescript
 * questo metodo restituisce vero anche se val è una chiave della enum e la enum è una enum NUMERICA
 *
 *
 * @author Riccardo Di Dato (shatsu)
 */
export function inEnum(val, EnumType) {
    return getEnumTypeChecker(EnumType)(val);
}
export function getEnumTypeChecker(e) {
    return (token) => {
        return Object.values(e).includes(token);
    };
}
/**
 * Genera dinamicamente una typeguard che effettua un check isArrayOf
 *
 * @author Riccardo Di Dato (shatsu)
 */
export function getArrayOfTypeguard(guard) {
    return (x) => {
        return isArrayOf(x, guard);
    };
}
/**
 * Genera dinamicamente una typeguard che effettua un check isArrayOf
 *
 * @author Riccardo Di Dato (shatsu)
 */
export function getMapOfTypeguard(guard) {
    return (x) => {
        return isMapOf(x, guard);
    };
}
export function isValidJson(x) {
    if (!isString(x)) {
        return false;
    }
    try {
        JSON.parse(x);
        return true;
    }
    catch (e) {
        return false;
    }
}
